
// By default, devices will go yellow after 1 hour without an uplink and red
// after 3 hours. Some device types do not uplink for multiple hours, by design.
// Those devices have an uplink lateny override here.
// Format is deviceType: minLatecy in seconds
export const deviceUplinkColors = {
  "oyster3": 14700 // 4h:5m for yellow, and then 7h:5m (+10800) for red
}
